export default {"src":"/_next/static/media/avatar.fc45246e.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};